module.exports = __webpack_public_path__ + "static/media/logo.92b9db52.svg";